import '../../components.theme/page-shops-view/page-shops-view';
import './page-shops-view.scss';
